import { useContext } from 'react'
import { Box } from '@mui/material'
import { AuthContext } from 'contexts/AuthContext'

const ImpersonationTopBar = () => {
  const { isImpersonated, impersonatedEmail } = useContext(AuthContext)

  if (!isImpersonated || !impersonatedEmail) return null

  return (
    <Box
      sx={{
        backgroundColor: '#FFF3CD',
        color: '#856404',
        padding: '8px 16px',
        textAlign: 'center',
        fontWeight: 500
      }}
    >
      Logged in as: {impersonatedEmail}
    </Box>
  )
}

export default ImpersonationTopBar
